import TextInput from '@components/text-input/TextInput';
import SelectInput from '@components/select/Select';
import TextAreaInput from '@components/textarea/TextArea';

import { handleIntegerChange } from '@src/utils/regex';

import { useFormContext } from 'react-hook-form';
import { useRequest } from '@stores';

const PermitsDredgeTransportation = ({ handleChange = () => {} }) => {
  const { watch } = useFormContext();
  const isReadOnly = useRequest((state) => state.isFormReadOnly);

  const isSiteDesignatedForDISP = watch('isSiteDesignatedForDISP');

  return (
    <>
      <div>
        <SelectInput
          className='width-50'
          fullWidth={false}
          name='isSiteDesignatedForDISP'
          label='Has the proposed disposal site been designated for use by the Administrator, EPA, pursuant to Section 102(c) of the Marine Protection, Research, and Sanctuaries Act of 1972, as amended (33 U.S.C. 1413)?'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        >
          <option key='2' value='true'>
            Yes
          </option>
          <option key='3' value='false'>
            No
          </option>
        </SelectInput>
      </div>
      {isSiteDesignatedForDISP === 'false' && (
        <>
          <div>
            <TextAreaInput
              name='disposalSiteCharacteristics'
              label='Describe the characteristics of the proposed disposal site and an explanation as to why no previously designated disposal site is feasible.'
              onChange={handleChange}
              readOnly={isReadOnly}
              required
            />
          </div>
        </>
      )}
      <div>
        <TextAreaInput
          name='knownDredgeMaterialDischarges'
          label='Describe known dredged material discharges at the proposed disposal site'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
      <div>
        <TextAreaInput
          name='previousDisposals'
          label='Provide the existence and documented effects of other authorized disposals that have been made in the disposal area (e.g., heavy metal background reading and organic carbon content)'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
      <div>
        <TextInput
          className='width-50'
          type='number'
          valueAsNumber
          name='estNumberOfMonthsOnSite'
          label='Provide the estimated length of time during which the disposal would continue at the proposed site (months)'
          readOnly={isReadOnly}
          onChange={(event) => {
            handleChange();
            handleIntegerChange(event);
          }}
          required
        />
      </div>
      <div>
        <TextAreaInput
          name='materialSource'
          label='Provide the source of the material'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
      <div>
        <TextAreaInput
          name='materialTypeAndComp'
          label='Describe the type and composition of the material'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
      <div>
        <TextAreaInput
          name='transportationAndDisposalMethod'
          label='Describe the method of transportation and disposal of the material'
          onChange={handleChange}
          readOnly={isReadOnly}
          required
        />
      </div>
    </>
  );
};

export default PermitsDredgeTransportation;
